import { useTranslate } from "@similarweb/i18n-provider";

import { EmployeeProfileConfirmationModal } from "../EmployeeProfileConfirmationModal/EmployeeProfileConfirmationModal";

type EditSharedEmployeeProfileModalProps = {
    isOpen: boolean;
    onCancel: () => void;
    onConfirm: () => void;
};

export const EditSharedEmployeeProfileModal = ({
    isOpen,
    onCancel,
    onConfirm,
}: EditSharedEmployeeProfileModalProps) => {
    const { translate } = useTranslate();

    return (
        <EmployeeProfileConfirmationModal
            isOpen={isOpen}
            titleKey="si.employee-profiles.edit.shared.title"
            description={translate("si.employee-profiles.edit.shared.description")}
            confirmLabel={translate("si.employee-profiles.edit.shared.confirm")}
            confirmButtonType="primary"
            onCancel={onCancel}
            onConfirm={onConfirm}
            dataAutomation="edit-shared-employee-profile-modal"
        />
    );
};
